export const jbmLangSettings = {
  digitalTwinSingleLabel: "inventory:tabs.vehicle.single_label",
  digitalTwinLabel: "inventory:tabs.vehicle.label",
  digitalTwinAddResource: "inventory:tabs.vehicle.add_resource",
};
